import { ReactComponent as Js } from '../assets/skills/js.svg'
import { ReactComponent as IconReact } from '../assets/skills/react.svg'
import { ReactComponent as Ts } from '../assets/skills/ts.svg'
import { ReactComponent as Redux } from '../assets/skills/redux.svg'
import { ReactComponent as StyledC } from '../assets/skills/styled.svg'
import { ReactComponent as Sass } from '../assets/skills/sass.svg'
import { ReactComponent as Boot } from '../assets/skills/boot.svg'
import { ReactComponent as Html } from '../assets/skills/html.svg'
import { ReactComponent as Css } from '../assets/skills/css.svg'

export const ListSkills = [
  {
    component: <Js />,
    key: 'JavaScript',
    id: 1,
    color: '#f7e61f'
  },
  {
    component: <IconReact />,
    key: 'React',
    id: 2,
    color: '#5ED3F3'
  },
  {
    component: <Ts />,
    key: 'TypeScript',
    id: 3,
    color: '#0076C6'
  },
  {
    component: <Redux />,
    key: 'Redux',
    id: 4,
    color: '#7248B6'
  },
  {
    component: <StyledC />,
    key: 'Styled-Component',
    id: 5,
    color: '#E7A2E1'
  },
  {
    component: <Sass />,
    key: 'Sass',
    id: 6,
    color: '#C96195'
  },
  {
    component: <Boot />,
    key: 'Bootstrap',
    id: 7,
    color: '#533B78'
  },
  {
    component: <Css />,
    key: 'CSS',
    id: 8,
    color: '#254BDD'
  },
  {
    component: <Html />,
    key: 'HTML',
    id: 9,
    color: '#F76300'
  }
]
